import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import PartnershipsPage from "@/pages/PartnershipsPage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/partnerships" element={<PartnershipsPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
